// URL ↔ section tables for the Scenes menu. Pure data, no React, so the
// same source serves useRoute (runtime) and vite.config.js (build-time
// preload of the landing section's hero or plate photo).
//
// Every URL the book ever served keeps working (printed QR cards, shares),
// plus the short aliases from the design handoff.
export const ROUTES = {
  '/': 's-top',
  '/coffee': 's-coffee', '/coffee/cover': 's-coffee', '/coffee/back': 'footer',
  '/coffee/espresso/black': 's-esp', '/coffee/espresso/milk': 's-milk',
  '/coffee/filter/microlots': 's-micro', '/coffee/filter/experimental': 's-exp', '/coffee/filter/estates': 's-est',
  '/signatures': 's-sig', '/signatures/velvet': 's-sig', '/signatures/matcha': 's-matcha', '/signatures/montblanc': 's-mont', '/signatures/back': 'footer',
  '/food': 's-food', '/food/cover': 's-food', '/food/back': 'footer',
  '/food/pasta': 's-pasta', '/food/fish-brunch': 's-fish', '/food/rice': 's-rice', '/food/burger-pizza': 's-pizza',
  '/food/bites': 's-bites', '/food/dessert': 's-dessert', '/food/bakery-smoothies': 's-bakery', '/food/drinks': 's-tea',
  // Short aliases from the handoff README.
  '/cover': 's-top', '/back': 'footer',
  '/espresso/black': 's-esp', '/espresso/milk': 's-milk',
  '/filter': 's-filter', '/filter/microlots': 's-micro', '/filter/experimental': 's-exp', '/filter/estates': 's-est',
  '/pasta': 's-pasta', '/fish': 's-fish', '/rice': 's-rice', '/pizza': 's-pizza', '/bites': 's-bites',
  '/dessert': 's-dessert', '/bakery': 's-bakery', '/tea': 's-tea',
};

// Section → canonical path written to the address bar (the existing forms,
// so nothing printed has to change).
export const CANON = {
  's-top': '/',
  's-sig': '/signatures', 's-matcha': '/signatures/matcha', 's-mont': '/signatures/montblanc',
  's-coffee': '/coffee', 's-esp': '/coffee/espresso/black', 's-milk': '/coffee/espresso/milk',
  's-filter': '/filter', 's-micro': '/coffee/filter/microlots', 's-exp': '/coffee/filter/experimental', 's-est': '/coffee/filter/estates',
  's-food': '/food', 's-pasta': '/food/pasta', 's-fish': '/food/fish-brunch', 's-rice': '/food/rice', 's-pizza': '/food/burger-pizza',
  's-bites': '/food/bites', 's-dessert': '/food/dessert', 's-bakery': '/food/bakery-smoothies', 's-tea': '/food/drinks',
  footer: '/coffee/back',
};

export const TITLES = {
  's-top': 'Salésol — the menu', 's-sig': 'Salésol — Signatures', 's-matcha': 'Salésol — Ceremonial Matcha', 's-mont': 'Salésol — Mont Blanc',
  's-coffee': 'Salésol — Coffee', 's-esp': 'Salésol — Espresso, black', 's-milk': 'Salésol — Espresso, milk-based',
  's-filter': 'Salésol — Filter', 's-micro': 'Salésol — The microlots', 's-exp': 'Salésol — The experimental exotics', 's-est': 'Salésol — The exotic estates',
  's-food': 'Salésol — Food', 's-pasta': 'Salésol — Fresh pasta', 's-fish': 'Salésol — Fish & Brunch', 's-rice': 'Salésol — Rice', 's-pizza': 'Salésol — Burger & Pizza',
  's-bites': 'Salésol — Bites', 's-dessert': 'Salésol — Plated dessert', 's-bakery': 'Salésol — Bakery & Smoothies', 's-tea': 'Salésol — Tea & water',
  footer: 'Salésol — BSD City',
};

export function resolve(pathname) {
  const p = (pathname || '/').replace(/\/+$/, '') || '/';
  if (p.startsWith('/non-coffee')) return 's-tea';
  return ROUTES[p] || 's-top';
}
